import { render, staticRenderFns } from "./tutorialModal.vue?vue&type=template&id=4c010ee0&lang=pug&"
import script from "./tutorialModal.vue?vue&type=script&lang=js&"
export * from "./tutorialModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports